import { _sharedActionsConstantsFeaturedSearch } from "./actions";

export const initialState = {
  results: [],
  params: {
    query: "",
    langs: null,

    paraId: "",
  },
  section: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case _sharedActionsConstantsFeaturedSearch.FETCH_SUCCESS: {
      const stateNew = { ...state };

      stateNew.results = action.data.data;
      stateNew.params = action.data.params;

      return stateNew;
    }
    case _sharedActionsConstantsFeaturedSearch.SET_SECTION: {
      return {
        ...state,
        section: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
